import { useMutation, useQueryClient } from "@tanstack/react-query";

import { sessionQueryKeys } from "@/entities/session/api/queryKeys";
import { useSessionStore } from "@/entities/session/models/store/useSessionStore";
import { GetApiInternalUser200, PutApiInternalUserBody } from "@/schemas";
import { putApiInternalUser } from "@/shared/api/user";
import { CustomAxiosError } from "@/shared/model/types/axiosError";

/**
 * Marks the tutorial as passed (finished or skipped) on the backend,
 * so it is not shown automatically again.
 */
export const useCompleteTutorial = () => {
    const queryClient = useQueryClient();

    return useMutation<unknown, CustomAxiosError, void>({
        mutationKey: ["completeTutorial"],
        mutationFn: () => {
            const { accountInfo } = useSessionStore.getState();
            // Same payload shape as the profile form: current user + changed field
            const payload: PutApiInternalUserBody = { ...accountInfo, tutorial_completed: true };

            return putApiInternalUser(payload);
        },
        onMutate: () => {
            const { accountInfo, setAccountInfo } = useSessionStore.getState();
            if (accountInfo) setAccountInfo({ ...accountInfo, tutorial_completed: true });

            queryClient.setQueryData<GetApiInternalUser200>(sessionQueryKeys.user, (old) =>
                old?.data ? { ...old, data: { ...old.data, tutorial_completed: true } } : old,
            );
        },
    });
};
